import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import { HttpHelper } from '../../shared/http-helper';

import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';

@Injectable()
export class RegionalReviewService {}


/** WEBPACK FOOTER **
 ** ./app/system-management/regional-review/regional-review.service.ts
 **/